module.exports.EXTERNAL_NAME = 'gafIdentityClientV4'